import api from '@/common/api';
import apiAI from '@/common/api-ai';
import { waitFor, sleep, createUUID } from '@/common/util.js';
import Vue from 'vue';
/* eslint-disable */

const initialState = () => ({
  enabled: true,

  ws: null,
  connected: false,
  pingTimer: null,
  chats: [],
  chat: null,
  chat_id: 0,
  cancelSendingFiles: false,
  currentAbortController: null,
  loading: {
    load: false,loadChat: false,
    addUserMsg: false,
    aiThinks: false,
    pdf: false,
    rename: false,
    delete: false,
  },
  errors: {
    load: [],
    addUserMsg: [],
    aiThinks: [],
  },
  strMessageDisabled: '',
});


export default {
  namespaced: true,
  state: initialState,
  getters: {
    enabled: (state) => state.enabled,
    loading: (state) => state.loading,
    connected: (state) => state.connected && state.ws && state.ws.readyState === WebSocket.OPEN,
    chat: (state) => state.chat,
    curChatId: (state) => state.chat_id,
    userIdHash: (state, getters, rootState, rootGetters) => {
      const user = rootGetters['auth/user']
      return user.user.toString()
      // const SECRET = 0x5f3759df;
      // const xored = user.id ^ SECRET
      // const checksum = (xored & 0xFF).toString(16).padStart(2, '0')
      // const payload = xored.toString(36)
      // return `${payload}-${checksum}`
      // DECODE
      // const [payload, checksum] = encoded.split('-')
      // if (!payload || !checksum) return null
      // const xored = parseInt(payload, 36)
      // const expectedChecksum = (xored & 0xFF).toString(16).padStart(2, '0')
      // if (checksum !== expectedChecksum) return null
      // return xored ^ SECRET
    },
    lastMsgThinking: (state) => state.chat?.findLast(el => el.author === 'ai' && el.loading),
    strMessageDisabled: (state) => state.strMessageDisabled,
  },
  mutations: {
    startLoading(state, field) {
      state.loading[field] = true;
    },
    startLoadingId(state, { field, id }) {
      state.loading[field] = id;
    },
    endLoading(state, field) {
      state.loading[field] = false;
    },
    clearError(state) {
      state.errors = initialState().errors;
    },
    setError(state, {type, errors}) {
      state.errors[type] = errors;
    },

    setAIEnabled(state, enabled) {
      state.enabled = enabled;
    },
    setConnected(state, connected) {
      state.connected = connected
    },
    setSocket(state, ws) {
      state.ws = ws
    },
    addMessage(state, msg) {

      const lastMsg = state.chat.length ? state.chat[state.chat.length-1] : null
      // console.log('addMessage', msg, 'lastMsg', lastMsg)

      if (lastMsg && (lastMsg.loading || lastMsg.error) && lastMsg.author === 'ai' && msg.author === 'ai') {
        // Если последнее сообщение от AI и оно в процессе загрузки или ошибка, то обновляем его
        lastMsg.text = msg.text
        lastMsg.error = msg.error
        lastMsg.loading = msg.loading
        // Очистить таймер, если он был
        if (lastMsg.timeoutId) {
          clearTimeout(lastMsg.timeoutId);
          console.log('timer cleared');
          lastMsg.timeoutId = null;
        }
        return
      } else if (lastMsg && lastMsg.loading && lastMsg.author === 'ai' && msg.author !== 'ai' ) {
        // Если последнее сообщение от АИ и оно в процессе загрузки, и приходит от юзера, вставляеем перед ним, потому что по факту оно приходит позже, чем ожидающее от АИ
        state.chat.splice(-1, 0, msg)
        return
      }
      state.chat.push(msg)


      // const lastMsgThinking = state.chat.length ? state.chat[state.chat.length-1]  (el => el.author === 'ai' && (el.loading || el.error));
      // console.log('addMessage', msg, 'lastMsgThinking', lastMsgThinking)
      // if (lastMsgThinking) {
      //   if (msg.author === 'ai') {
      //     // Очистить таймер, если он был
      //     if (lastMsgThinking.timeoutId) {
      //       clearTimeout(lastMsgThinking.timeoutId);
      //       console.log('timer cleared');
      //       lastMsgThinking.timeoutId = null;
      //     }
      //     lastMsgThinking.loading = false;
      //     lastMsgThinking.error = '';
      //     lastMsgThinking.text = msg.text;
      //   } else {
      //     state.chat.splice(-1, 0, msg)
      //   }
      // } else {
      //   state.chat.push(msg)
      // }
    },
    setChats(state, items) {
      state.chats = items
    },
    newChat(state, chat) {
      state.chats.unshift(chat)
    },
    setChatName(state, {id, title}) {
      const item = state.chats.find(el=> el.chat_id === id)
      if (item)
        item.title = title
    },
    deleteChat(state, id) {
      if (id === state.chat_id) {
        state.chat = []
        state.chat_id = 0
      }
      state.chats = state.chats.filter(el=> el.chat_id !== id)
    },
    setChat(state, items) {
      state.chat = items
    },
    setChatId(state, id) {
      state.chat_id = id
    },
    setEnabled(state, enabled) {
      state.enabled = enabled
    },

    setCancelSendingFiles(state, value) {
      state.cancelSendingFiles = value
      if (value) {
        const controller = state.currentAbortController
        if (controller) {
          controller.abort()
        }
      }
    },
    setCurrentAbortController(state, controller) {
      state.currentAbortController = controller
    },
    setStrMessageDisabled(state, str) {
      state.strMessageDisabled = str
    }
  },
  actions: {
    async loadEnabled({ commit, state, getters, rootGetters }) {
      commit('startLoading', 'load');
      try {
        const dt = await api.get(`/ai-expert/usage/summary/`, { timeout: 0 })
        commit('setEnabled', dt?.allowed);
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'load', errors: err.data });
          Vue.prototype.$toast.error("Не удалось соединиться с AI-сервером", '', { position: 'topRight' });
          commit('setAIEnabled', false);

      } finally {
        commit('endLoading', 'load');
      }
    },

    async loadChats({ commit, state, getters, dispatch, rootGetters }) {
      dispatch('loadEnabled');
      commit('startLoading', 'load');
      try {
        const chats = await apiAI.get(`/chats/${getters.userIdHash}`)
        chats.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))

        commit('setChats', chats);
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'load', errors: err.data });
          Vue.prototype.$toast.error("Не удалось соединиться с AI-сервером", '', { position: 'topRight' });
          commit('setAIEnabled', false);

      } finally {
        commit('endLoading', 'load');
      }
    },

    async newChat({ commit, dispatch, state, getters, rootGetters }) {
      commit('startLoading', 'loadChat');

      try {
        const chat = await apiAI.post(`/chats`, {
          user_id: getters.userIdHash,
          title: 'Новый чат ' + new Date().toLocaleString()
        })
        if (chat) {
          commit('newChat', chat);
          commit('setChat', []);
          await dispatch('connect', chat.chat_id)
        }

      } catch (err) {
          console.log(err);
          commit('setError', { type: 'loadChat', errors: err.data });
      } finally {
        commit('endLoading', 'loadChat');
      }
    },

    async loadChat({ commit, dispatch, state, getters, rootGetters }, id) {
      commit('startLoading', 'loadChat');

      try {
        commit('setChat', []);
        await dispatch('connect', id)
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'loadChat', errors: err.data });
      } finally {
        commit('endLoading', 'loadChat');
      }
    },

    async setChatName({ commit, state, getters, rootGetters }, {id, title}) {
      commit('startLoading', 'rename');
      try {
        const chats = await apiAI.put(`/chats/${getters.userIdHash}/${id}/title`, { title })
        commit('setChatName', { id, title });
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'rename', errors: err.data });
      } finally {
        commit('endLoading', 'rename');
      }
    },

    async deleteChat({ commit, state, getters, rootGetters }, id) {
      commit('startLoading', 'delete');
      try {
        const response = await apiAI.delete(`/chats/${getters.userIdHash}/${id}`, )
        commit('deleteChat', id);
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'delete', errors: err.data });
      } finally {
        commit('endLoading', 'delete');
      }
    },

    async chatToPdf({ state, commit, dispatch, getters }) {
      commit('startLoading', 'pdf');

      try {
        const response = await api.post(`/ai-expert/export-chat-to-pdf/`, {
          report_type: "ai_chat",
          logo: true,
          items: state.chat
        }, { timeout: 0 })
        return response
      } catch (err) {
          console.log(err);
          commit('setError', { type: 'pdf', errors: err.data });
      } finally {
        commit('endLoading', 'pdf');
      }
    },

    async addUserMessage({ state, commit, dispatch, getters }, text) {
      if (!state.connected && state.chat_id) {
        await dispatch('connect', state.chat_id)
      }

      await dispatch('addUsage', text);
      if (!state.enabled) {
        return;
      }

      if (!state.chat) {
        await dispatch('newChat')
        await waitFor(() => state.connected)
      }

      if (state.chat.length === 0) {
        const title = text.length > 80 ? text.substring(0, 80) + '...' : text
        await dispatch('setChatName', { id: state.chat_id, title })
      }

      const sendedOk = await dispatch('sendFiles')
      if (!sendedOk)
        return
      if (getters.connected) {
        state.ws.send(JSON.stringify({ content: text }))

        if (!getters.lastMsgThinking) {
          // Добавляем сообщение ожидания и таймер на 2 минуты
          const waitingMsg = { author: 'ai', text: "", loading: true, error: '' };
          // Сохраняем ссылку на таймер прямо в объекте сообщения
          waitingMsg.timeoutId = setTimeout(() => {
            waitingMsg.error = "AI-эксперт не отвечает, попробуйте сократить вопрос или переформулировать его";
            waitingMsg.loading = false;
          }, 2 * 60 * 1000);
          commit('addMessage', waitingMsg);
          await sleep(1)
        }
      } else {
        commit('addMessage', { author: 'user', text, error: "Сообщение не доставлено, нет связи с AI-агентом" });
      }
    },

    async sendFiles({ state, commit, dispatch, getters, rootGetters }) {
      const pendingFiles = rootGetters['ai/dossier/pendingFiles']

      for (let i=0 ; i<pendingFiles.length ; i++) {
        commit('ai/dossier/setPendingFileInfo', {ind: i, sending: true }, { root: true })
        const fileItem = pendingFiles[i]

        if (state.cancelSendingFiles) {
          console.log('Загрузка отменена пользователем')
          break
        }
        const controller = new AbortController()
        commit('setCurrentAbortController', controller)

        try {
          let content = ''
          if (fileItem.fromDossier) {
            const response = await api.get(`/dossier/${fileItem.id}/extract-text/`, { signal: controller.signal, timeout: 0 })
            if (response)
              content = response.text
              // console.log('dossier', fileItem, content)
          } else {
              const form = new FormData()
              form.append('file', fileItem.file)
              const response = await api.post( `/ai-expert/extract-text/`, form, { signal: controller.signal, timeout: 0 })
              content = response.text
          }

          commit('ai/dossier/setPendingFileInfo', {ind: i, sending: false, sended: true, content }, { root: true })
        } catch (e) {
          commit('ai/dossier/setPendingFileInfo', {ind: i, sending: false, sended: false, error: true }, { root: true })
          console.log(e)
        }
      }

      if (!state.cancelSendingFiles) {
        for (let i=0 ; i<pendingFiles.length ; i++) {
          const fileItem = pendingFiles[i]
          if (fileItem.sended)
            state.ws.send(JSON.stringify({ filename: fileItem.name, content: fileItem.content }))
        }
      }

      // commit('ai/dossier/setPendingFiles', [], { root: true })
      const cancel = state.cancelSendingFiles
      commit('setCancelSendingFiles', false)
      commit('setCurrentAbortController', null)
      return !cancel
    },

    connect({ commit, dispatch, state, getters, rootGetters }, chat_id) {
      if (state.ws) {
        state.ws.close()
      }
      if (!chat_id) {
        console.error('chat_id empty')
        return
      }

      try {
        let host = process.env.VUE_APP_BASE_URL_AI_WS
        host = host.endsWith("/") ? host.slice(0, -1) : host;

        const socket = new WebSocket(`${host}/chat/${getters.userIdHash}/${chat_id}`)

        socket.addEventListener("open", () => {
          console.log("WebSocket connected")
          commit('setConnected', true)
          commit('setChatId', chat_id);
          socket.send(JSON.stringify({ type: "get_history", chat_id }))
          state.pingTimer = setInterval(()=>{
            socket.send(JSON.stringify({ type: "ping" }))
          }, 60*1000)
        })

        socket.addEventListener("message", (event) => {
            const data = JSON.parse(event.data)
            // console.log('message', data)
            function convertMsg(src) {
              return {
                author: src.sender_id === getters.userIdHash ? 'user' : 'ai',
                text: src.content,
                loading: false,
                timestamp: src.timestamp,
                filename: src.filename,
                error: ''
              }
            }

            if (Array.isArray(data)) {
              // если сервер шлёт массив целиком
              // messages.value.push(...data)
            } else if (Array.isArray(data.messages)) {
              // если объект { messages: [...] }
              // messages.value.push(...data.messages)
            } else {
              // если пришло одно сообщение
              commit('addMessage', convertMsg(data));
            }
        })

        socket.addEventListener("close", (event) => {
          commit('setConnected', false)
          clearInterval(state.pingTimer)
          state.pingTimer = 0
          console.log('WS closed')
        })

        commit('setSocket', socket)
      }
      catch(e) {
        console.log(e)
      }
    },

    async addUsage({ commit, dispatch, state, getters, rootGetters }, text) {
      commit('startLoading', 'addUserMsg');

      try {
        const response = await api.post(`/ai-expert/usage/consume/`, {
          amount: 1,
          idempotency_key: createUUID(),
          prompt_text: text
        }, { timeout: 0 })
        return response
      } catch (err) {
          console.log(err);
          commit('setStrMessageDisabled', err.data.error);
          commit('setEnabled', false);
          Vue.prototype.$toast.error(err.data.error, '', { position: 'topRight' });
          return false; 
      } finally {
        commit('endLoading', 'addUserMsg');
      }
    }

  },
};
